import React, { useState } from "react";
import {
	TextField,
	Button,
	Paper,
	Typography,
	CircularProgress,
	FormControl,
	Box,
	InputLabel,
	Select,
	MenuItem,
	CssBaseline,
	Divider,
} from "@mui/material";
import { motion } from "framer-motion";
import { styled } from "@mui/material/styles";
import { ThemeProvider, createTheme } from "@mui/material/styles";
import { useNavigate } from "react-router-dom"; // for navigation
import axios from "../../api/axios"; // your axios instance
import { countries } from "../../data";
import { Link } from "react-router-dom";
import axiosLib from "axios";

const StyledPaper = styled(Paper)(({ theme }) => ({
	padding: theme.spacing(4),
	display: "flex",
	flexDirection: "column",
	alignItems: "center",
	justifyContent: "center",
	maxWidth: 400,
	margin: "auto",
	borderRadius: "20px",
	boxShadow: theme.shadows[5],
	transition: "transform 0.2s",
	"&:hover": {
		transform: "scale(1.03)",
	},
}));

const RegisterForm = () => {
	const navigate = useNavigate();

	// State variables for form inputs
	const [fullName, setFullName] = useState("");
	const [phoneNumber, setPhoneNumber] = useState("");
	const [email, setEmail] = useState("");
	const [password, setPassword] = useState("");
	const [repeatPassword, setRepeatPassword] = useState("");
	const [selectedCountry, setSelectedCountry] = useState("");
	const [error, setError] = useState(""); // For user-visible error messages
	const [loading, setLoading] = useState(false);
	const [successMsg, setSuccessMsg] = useState("");

	const handleRegister = async (e) => {
		e.preventDefault();
		setError("");
		setSuccessMsg("");

		// Basic validation
		if (!fullName.trim()) {
			setError("Please enter your full name.");
			return;
		}
		if (!phoneNumber.trim()) {
			setError("Please enter your phone number.");
			return;
		}
		if (!validateEmail(email)) {
			setError("Please enter a valid email address.");
			return;
		}
		if (password !== repeatPassword) {
			setError("Passwords do not match.");
			return;
		}
		if (!selectedCountry) {
			setError("Please select a country.");
			return;
		}

		console.log({
			fullName,
			phoneNumber,
			email,
			password,
			country: selectedCountry,
		});
		setLoading(true);
		try {
			const response = await axios.post("/register", {
				fullName,
				phoneNumber,
				email,
				password,
				country: selectedCountry,
			});

			console.log("Registration successful:", response);
			setSuccessMsg("Registration successful! Redirecting to login...");
			setTimeout(() => {
				navigate("/en/login");
			}, 1500);
		} catch (err) {
			if (axiosLib.isAxiosError(err)) {
				if (err.response && err.response.data) {
					setError(err.response.data.message || "Registration failed");
				} else if (err.message) {
					setError(err.message);
				} else {
					setError("An unknown error occurred");
				}
			} else {
				setError("An unexpected error occurred");
			}
		} finally {
			setLoading(false);
		}
	};

	const validateEmail = (email) => {
		const re = /\S+@\S+\.\S+/;
		return re.test(email);
	};

	console.log({
		fullName,
		phoneNumber,
		email,
		password,
		country: selectedCountry,
	});

	return (
		<motion.div
			initial={{ opacity: 0, y: -30 }}
			animate={{ opacity: 1, y: 0 }}
			transition={{ duration: 0.5 }}
			className=" my-[5rem]  w-[90%] mx-auto">
			<StyledPaper elevation={3}>
				<Box
					sx={{
						position: "relative",
						mb: 2,
						textAlign: "left",
						background: "linear-gradient(to top, white , #162027  10%)",
						borderRadius: "12px 12px 0 0",
						p: "0.7rem",
						minHeight: "6rem",
					}}>
					<Box>
						<Typography
							variant="h6"
							sx={{ fontWeight: "medium", color: "white" }}
							gutterBottom>
							Create your account
						</Typography>
						<Divider
							sx={{
								bgcolor: "#F5F5F5",
								width: "40%",
								my: "0.5rem",
								height: "0.1rem",
							}}
						/>
						<Typography
							// variant="h6"
							sx={{
								fontWeight: "thinner",
								// my: "0.5rem",
								color: "#F5F5F5",
								fontSize: "0.8rem",
								color: "gray",
								// mb: "0.3rem",
							}}
							gutterBottom>
							Become part of a community of more than 3 million traders.
						</Typography>
					</Box>
					{/* <div className="custom-shape-divider-bottom-1760358638">
						<svg
							data-name="Layer 1"
							xmlns="http://www.w3.org/2000/svg"
							viewBox="0 0 1200 120"
							preserveAspectRatio="none">
							<path
								d="M1200 0L0 0 598.97 114.72 1200 0z"
								className="shape-fill"></path>
						</svg>
					</div> */}
				</Box>
				<form onSubmit={handleRegister} style={{ width: "100%" }} noValidate>
					<Box
						sx={{
							// background: "linear-gradient(to top, white , #F5F5F5  20%)",
							// border: "1px solid #F5F5F5",
							// p: "2 0",
							borderRadius: "8px",
							mb: 1,
							display: "grid",
							gridTemplateColumns: { xm: "1fr", sm: "2fr 2fr" },
							gap: 1,
						}}>
						{/* Full Name */}
						<TextField
							label="Full Name"
							variant="standard"
							fullWidth
							margin="normal"
							required
							value={fullName}
							onChange={(e) => setFullName(e.target.value)}
						/>
						{/* Phone Number */}
						<TextField
							label="Phone Number"
							variant="standard"
							fullWidth
							margin="normal"
							required
							value={phoneNumber}
							onChange={(e) => setPhoneNumber(e.target.value)}
						/>
						{/* Email */}
						<TextField
							label="Email"
							variant="standard"
							fullWidth
							margin="normal"
							required
							value={email}
							onChange={(e) => setEmail(e.target.value)}
						/>
						{/* Password */}
						<TextField
							label="Password"
							type="password"
							variant="standard"
							fullWidth
							margin="normal"
							required
							value={password}
							onChange={(e) => setPassword(e.target.value)}
						/>
						{/* Repeat Password */}
						<TextField
							label="Repeat Password"
							type="password"
							variant="standard"
							fullWidth
							margin="normal"
							required
							value={repeatPassword}
							onChange={(e) => setRepeatPassword(e.target.value)}
						/>
						{/* Country Selector */}
						<FormControl variant="standard" fullWidth margin="normal" required>
							<InputLabel>Country</InputLabel>
							<Select
								value={selectedCountry}
								onChange={(e) => setSelectedCountry(e.target.value)}
								label="Country">
								{countries.map((country) => (
									<MenuItem key={country.code} value={country.name}>
										{country.name}
									</MenuItem>
								))}
							</Select>
						</FormControl>
					</Box>

					{/* Submit Button */}
					<Button
						type="submit"
						variant="contained"
						color="primary"
						fullWidth
						disabled={loading}
						sx={{ position: "relative", bgcolor: "black" }}>
						{loading && (
							<CircularProgress
								size={24}
								sx={{
									position: "absolute",
									top: "50%",
									left: "50%",
									transform: "translate(-50%, -50%)",
								}}
							/>
						)}
						{!loading && "Register"}
					</Button>
					{/* Error and Success Messages */}
					{error && (
						<Typography color="error" align="center" sx={{ mt: 2 }}>
							{error}
						</Typography>
					)}
					{successMsg && (
						<Typography color="primary" align="center" sx={{ mt: 2 }}>
							{successMsg}
						</Typography>
					)}
				</form>
				{/* Link to Login */}
				<Typography variant="body2" align="center" sx={{ mt: 2 }}>
					Already have an account?{" "}
					<Link to="/en/login" className="text-blue-500">
						Login
					</Link>
				</Typography>
			</StyledPaper>
		</motion.div>
	);
};

const theme = createTheme({
	palette: {
		primary: { main: "#1976d2" },
		secondary: { main: "#dc004e" },
	},
});

export default function RegUtil() {
	return (
		<ThemeProvider theme={theme}>
			<CssBaseline />
			<div
				style={{
					display: "flex",
					alignItems: "center",
					justifyContent: "center",
					minHeight: "100vh",
					backgroundColor: "black",
				}}>
				<RegisterForm />
			</div>
		</ThemeProvider>
	);
}
